module.exports = __webpack_public_path__ + "img/waves-7.890a89cd.jpg";